<template>
  <el-dialog :title="title" :visible.sync="pageShow" width="800px" :before-close="handleClose">
    <div v-if="type === 1" class="detail" v-html="content_xy"></div>
    <div v-if="type === 2" class="detail" v-html="content_ys"></div>
  </el-dialog>
</template>

<script>
  import { richtextApi } from '@/http/api.js'
  export default {
    data() {
      return {
        pageShow: false,
        title: '',
        titleArr: ['服务协议', '隐私政策', 'XX 支付协议'],
        content_xy:'',
        content_ys:'',
        type:0
      }
    },
    mounted(){
      richtextApi({type:1}).then(res=>{
        this.content_xy = res;
      })
      richtextApi({type:2}).then(res=>{
        this.content_ys = res;
      })
    },
    methods: {
      open(num) {
        this.title = this.titleArr[num-1];
        this.pageShow = true;
        this.type = num
      },
      handleClose() {
        this.pageShow = false;
      },
    },
  }
</script>

<style lang="scss" scoped>
  .scan {
    text-align: center;

    .tp {
      width: 190px;
    }

    .tit {
      margin-top: 20px;

      span {
        display: inline-block;
        color: #999;
        position: relative;

        &::after,
        &::before {
          content: "";
          display: block;
          width: 60px;
          height: 1px;
          background-color: #999999;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }

        &::after {
          left: -80px;
        }

        &::before {
          right: -80px;
        }
      }
    }

    .desc {
      margin-top: 30px;
      font-size: 18px;
      color: #666;
    }
  }
</style>